import SectionHeading from "../components/SectionHeading";
import { MaskedLines, FadeIn, Reveal } from "../components/motion/Reveal";
import { useSettings } from "../context/SettingsContext";

const PrivacyPolicy = () => {
  const site = useSettings();
  
  const SECTIONS = [
    ["Information We Collect", "Contact details (name, company, email, phone, country) and order requirements (products, quantities, customization specs) that you submit through our inquiry and contact forms."],
    ["How We Use Information", "We use your information solely to prepare quotations, fulfill orders, communicate about your projects, and improve our service. We never sell your data."],
    ["Cookies", "This site uses minimal functional cookies only — no advertising trackers. Your inquiry selections may be stored locally in your browser for convenience."],
    ["Customer Data", "Customer records are stored securely and accessed only by the sales and production teams handling your account."],
    ["Inquiry Data", "Inquiry details — including logos, designs, and specifications you share — are treated as confidential and used only to quote and produce your order. NDA available on request."],
    ["Third-Party Services", "We share data only with logistics partners as needed to deliver your shipment, under their own privacy obligations."],
    ["Data Security", "Data is encrypted in transit and stored with restricted access. We retain inquiry records for 24 months unless you request earlier deletion."],
    ["Contact Information", `For any privacy questions or data requests, contact us at ${site.email} or ${site.phone}.`],
  ];

  return (
    <div data-testid="privacy-policy-page">
      <section className="border-b border-black/10 bg-white">
        <div className="mx-auto max-w-[1400px] px-5 pb-16 pt-16 md:pt-24 lg:px-10">
          <FadeIn>
            <p className="mono-caption mb-8 text-neutral-500">Policy — Last updated January 2026</p>
          </FadeIn>
          <h1 className="font-display text-4xl font-semibold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl">
            <MaskedLines lines={["PRIVACY", <>POLICY<span className="text-brand-red">.</span></>]} />
          </h1>
        </div>
      </section>
      <section className="mx-auto max-w-[1100px] px-5 py-20 md:py-28 lg:px-10">
        <SectionHeading number="01" title="Your Data, Respected" />
        <div className="divide-y divide-black/10 border-y border-black/10">
          {SECTIONS.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.03}>
              <div className="grid gap-2 py-7 sm:grid-cols-12" data-testid={`privacy-section-${i}`}>
                <span className="font-mono text-sm text-brand-red sm:col-span-1">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-display text-xl font-medium tracking-tight sm:col-span-4">{t}</h3>
                <p className="text-sm leading-relaxed text-neutral-500 sm:col-span-7">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
